import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis } from 'recharts';
import styles from "./graph.module.css";

// Данные для этапов
const stages = {
  20: { index: 0, title: "Высказываемся", text: "общаемся вокруг книги,\nделимся мыслями\nи впечатлениями" },
  60: { index: 1, title: "Исследуем", text: "на материале книги:\n- копаем вглубь культуры\n- ломаем грани актуального\nзнания\n- ставим новые вопросы\n- находим новые ответы\n- вникаем в книгу х10 через\nдругие произведения" },
  80: { index: 2, title: "Трещим", text: "общаемся,\nвысказываем\n догнавшие мысли" }
};

// Имитация плавной экспоненциальной кривой, идущей вверх к концу
const data = [
  { x: 0, y: 10, stage: stages[20] },
  { x: 5, y: 11 },
  { x: 10, y: 13 },
  { x: 16, y: 16 },
  { x: 22, y: 22 },
  { x: 22.5, y: 26, stage: stages[60] },
  { x: 27, y: 32 },
  { x: 32, y: 42 },
  { x: 37, y: 60 },
  { x: 42, y: 76 },
  { x: 47, y: 86 },
  { x: 53, y: 92, stage: stages[80] },
  { x: 58, y: 95 },
  { x: 64, y: 98 },
  { x: 70, y: 99.5 },
  { x: 76, y: 100 },
];


const chartDomain = { x: 80, y: 110 };
const ANIM_DURATION = 5500;

const StageDot = ({ cx, cy, payload }) => {
  if (!payload.stage) return null;

  const isUp = payload.stage.index < 2;

  return (
    <g className={styles.stageMarker} tabIndex={0}>
      <circle className={styles.stageDot} cx={cx} cy={cy} r="6" />
      <foreignObject className={styles.stageLabelWrap} x={cx + 12} y={cy - 18} width="400" height="400">
        <div className={`${styles.stageLabelBox} ${isUp ? styles.stageLabelUp : ''}`}>
          <span className={styles.chartStageTitle}>{payload.stage.title}</span>
          <span className={styles.stageTooltip}>
            {payload.stage.text.split('\n').map((line, lineIndex) => (
              <span key={line} className={styles.stageTooltipLine}>{line}</span>
            ))}
          </span>
        </div>
      </foreignObject>
    </g>
  );
};

export const EventTimelineChart = () => {
  return (
    <div className={styles.timelineContainer}>
      {/* График */}
      <div className={styles.chartWrapper}>
        <div className={styles.axisY}><div className={styles.axisYArrow} /></div>
        <div className={styles.axisX}><div className={styles.axisXArrow} /></div>

        <div className={styles.chartContainer} style={{ '--anim-dur': `${ANIM_DURATION}ms` }}>
          {/* Фоновые зоны этапов */}
          <div className={styles.chartStagesOverlay}>
            {Object.values(stages).map((stage, index) => (
              <div
                key={stage.title}
                className={styles.chartStageZone}
                style={{
                  backgroundColor: index === 0 ? 'rgba(192, 132, 252, 0.08)' :
                    index === 1 ? 'rgba(192, 132, 252, 0.12)' :
                      'rgba(192, 132, 252, 0.16)'
                }}
              />
            ))}
          </div>

          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 20, right: 40, left: 10, bottom: 0 }}>
              <XAxis dataKey="x" hide domain={[0, chartDomain.x]} />
              <YAxis hide domain={[0, chartDomain.y]} />
              <Area 
                type="monotone" 
                dataKey="y" 
                stroke="var(--color-accent-indigo)" 
                strokeWidth={3} 
                fill="transparent" 
                isAnimationActive={false}
                dot={<StageDot />}
                activeDot={false}
              />
            </AreaChart>
          </ResponsiveContainer>

          {/* Подпись под графиком */}
          <div className={styles.chartFooter}>
            <span className={styles.chartFooterText}>
              График доставки развития самосознания, нигде более не виданного (даже у Аристотеля)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
